import { useEffect } from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import { LEGAL_PAGES } from "../data/legal";
import { Reveal } from "../components/site/Reveal";

const Legal = ({ slug }) => {
  const page = LEGAL_PAGES[slug];

  useEffect(() => {
    document.title = `${page.title} — Medlyn 360`;
    return () => { document.title = "Medlyn 360 — Virtual Live Human Medical Scribing"; };
  }, [page]);

  return (
    <main data-testid={`legal-page-${slug}`}>
      <Navbar />
      <section className="bg-gradient-to-br from-white via-brand-sky-soft/60 to-white dark:from-brand-ink dark:via-[#0A1030] dark:to-brand-ink pt-32 pb-12 md:pt-40 md:pb-16 relative overflow-hidden">
        <div className="absolute -top-24 right-0 w-96 h-96 rounded-full bg-brand-sky/15 blur-3xl" />
        <div className="relative max-w-3xl mx-auto px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-sky mb-4">Legal</p>
          </Reveal>
          <Reveal delay={0.06}>
            <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-slate-900 dark:text-white leading-[1.1]" data-testid="legal-title">
              {page.title}
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-4 text-sm text-slate-400" data-testid="legal-effective-date">{page.effective}</p>
          </Reveal>
        </div>
      </section>
      <section className="bg-white dark:bg-brand-ink py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-6">
          <p className="text-base leading-[1.85] text-slate-600 dark:text-slate-300">{page.intro}</p>
          <div className="mt-10 space-y-10">
            {page.sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-lg md:text-xl font-semibold text-slate-900 dark:text-white">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="mt-3 text-[15px] leading-[1.85] text-slate-600 dark:text-slate-300">{para}</p>
                ))}
              </div>
            ))}
          </div>
          <p className="mt-12 rounded-2xl bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/10 p-5 text-xs leading-relaxed text-slate-400">
            This page is provided for general informational purposes and does not constitute legal advice.
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
};
export default Legal;
